import { Subject } from "@scrile/api-provider/dist/api/SubjectProvider";
import { TipSubjectType } from "@scrile/api-provider/dist/api/TipProvider";
import providers from "lib/providers";

export default function useController() {
  const sendTip = async (subject: Subject<TipSubjectType>, amount: number) => {
    await providers.TipProvider.create({
      data: {
        subject,
        amount,
      },
    });
  };

  return { sendTip };
}
